// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"735ce9ce","319":"23fa390d","388":"5a54fd96"}[chunkId] + ".chunk.js";
};